import { tr } from '@/lib/i18n-core';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/primitives';
import { VisitOrdersPanel } from '../../VisitOrdersPanel';
import { OrderSection, type OrderSectionProps } from './OrderSection';

export function ProcedureOrderSection(props: OrderSectionProps) {
  const encounterId = props.scope.encounterId;
  return (
    <OrderSection kind="procedure" {...props}>
      {encounterId && (
        <Card>
          <CardHeader>
            <CardTitle className="text-sm">{tr('opd', 'order_referral_admission')}</CardTitle>
            <p className="text-xs text-muted-foreground">{tr('opd', 'order_referral_admission_desc')}</p>
          </CardHeader>
          <CardContent>
            <VisitOrdersPanel encounterId={encounterId} patientId={props.patient.id} readOnly={props.readOnly} only="referral_admission" />
          </CardContent>
        </Card>
      )}
    </OrderSection>
  );
}
